export function filterName(val,key,list){
  let arr = list || []
  let res = arr.filter((v) => {
    return v[key] == val
  })
  if (res[0] && res[0].name) {
    return res[0].name
  }
  return ''
}
export const toThousands = (number, separator) => {
  var parts = ((number || number === 0 ? number : '') + '').split('.')
  if (parts.length){
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+\b)/g, '$1' + (separator || ','))
  }
  return parts.join('.')
}
